module.exports = __webpack_public_path__ + "img/valley_oak_636d_detail_rsh.f2d90e7b.jpg";